import { ref, watchEffect } from 'vue'
import { projectFirestore } from '../firebase/config'
// 取得單一document，要先傳入該document的id
const getDocument = (collection, id) => {

  const document = ref(null)
  const error = ref(null)

  // register the firestore document reference
  let documentRef = projectFirestore.collection(collection).doc(id)
  // 即時獲取
  const unsub = documentRef.onSnapshot(doc => {
    // 確認有該doc才會寫入document變數中回傳
    if(doc.data()){
      document.value = { ...doc.data(), id: doc.id};
      error.value = null
    } else{
      error.value = 'The document does not exist!'
    }
  }, err => {
    console.log(err.message)
    document.value = null
    error.value = 'could not fetch the data'
  })

  watchEffect((onInvalidate) => {
    onInvalidate(() => unsub());
  });

  return { error, document }
}

export default getDocument